import gql from 'graphql-tag';

export default gql`
  mutation cancelRsvpRepVisit($input: cancelRsvpRepVisitInput!) {
    cancelRsvpRepVisit(input: $input) {
      repVisit {
        id
        appointments {
          id
          status
          bookedByUser
          bookedByCollege
          currentColleges
          userBookingStatus
        }
        status
        currentColleges
      }
    }
  }
`;
